import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer
} from 'recharts';

const WeeklyActivityChart = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchActivity = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/dashboard/weekly-activity`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        });
        const result = await res.json();
        console.log("📊 Weekly activity data:", result);  // <-- add this
        setData(result);
      } catch (err) {
        console.error('Error loading weekly activity:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchActivity();
  }, []);

  const isAllZero = data.every(d => d.conversationsStarted === 0 && d.reportsCompleted === 0);

  if (loading) {
    return (
      <div className="bg-gray-100 border border-gray-200 p-4 rounded-lg shadow-sm flex items-center justify-center h-48">
        <div className="animate-spin rounded-full h-6 w-6 border-2 border-gray-400 border-t-transparent"></div>
      </div>
    );
  }

  if (isAllZero) {
    return (
      <div className="bg-gray-100 border border-gray-200 p-6 rounded-lg shadow-inner text-center">
        <h3 className="text-xl font-semibold text-gray-800 mb-2">Weekly Activity Overview</h3>
        <p className="text-gray-600 mb-4">No conversations or reports yet. Get started by exploring available scenarios.</p>
        <button
          onClick={() => navigate('/scenarios')}
          className="px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700 text-sm"
        >
          Explore Scenarios
        </button>
      </div>
    );
  }

  return (
    <div className="relative bg-gray-100 shadow-inner rounded-lg p-4 overflow-hidden">
      {/* Background pattern */}
      <span
        aria-hidden="true"
        style={{
          backgroundImage: "url('/patterns/bubbles.svg')",
          backgroundSize: "100%",
          opacity: 0.08,
        }}
        className="pointer-events-none absolute inset-0 bg-repeat z-0"
      />
  
      {/* Foreground content */}
      <div className="relative z-10">
        <h3 className="text-xl font-semibold text-gray-800 mb-4">Weekly Activity Overview</h3>
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={data}>
            <XAxis
              dataKey="week"
              tickFormatter={(_, index) => `Week ${data.length - index}`}
            />
            <YAxis />
            <Tooltip
              content={({ active, payload, label }) => {
                if (active && payload && payload.length) {
                  const weekIndex = data.findIndex(d => d.week === label);
                  const weekLabel = `Week ${data.length - weekIndex}`;
                  return (
                    <div className="bg-white p-2 rounded shadow text-sm text-gray-800">
                      <p className="font-semibold">{weekLabel}</p>
                      {payload.map((entry, i) => (
                        <p key={i} className="text-gray-600">
                          {entry.name}: {entry.value}
                        </p>
                      ))}
                    </div>
                  );
                }
                return null;
              }}
            />
            <Legend />
            <Bar dataKey="conversationsStarted" fill="#704ea0" name="Conversations" />
            <Bar dataKey="reportsCompleted" fill="#81c345" name="Reports" />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );  
};

export default WeeklyActivityChart;
